import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import {
  Autocomplete,
  Button,
  FormLabel,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { textStyle } from "../../styles/Style";
import "../../../components/styles/popupStyle.css";
import {
  checkData,
  checkDuplicate,
  deleteItem,
  fillAutocompleteValues,
  updateData,
} from "../../actions/actionItems";
import { removeSampleTestArray } from "../../actions/cleanup";
import AlertComponent from "../../subcomponents/AlertComponent";
import DraggableItemList from "../../subcomponents/DNDComponent";
import { retailRetailItemsTooltip } from "../../../constants/TooltipInformation";
import { fieldValidationHelperText } from "../../../constants/validationHelperText";
import { RetailPropertyEnum } from "../../../constants/NavbarList";
import {
  validateString,
  validationLength,
  validationMessages,
  validationType,
} from "../../actions/validations";
import { tooltipComponent } from "../../subcomponents/tooltipComponent";
import { buttonValues, DNDFieldsEnum } from "../../../constants/Types";
import { ClearButton } from "../../subcomponents/ClearButton";
import { CopyButton } from "../../subcomponents/CopyButton";
import useScrollToTop from "../../hooks/useScrollToTop";

const RetailRetailItems = ({
  data,
  fieldValues,
}: {
  data: (value: any) => void;
  fieldValues: any;
}) => {
  const [itemNumber, setItemNumber] = useState<string | null>(null);
  const [itemDescription, setItemDescription] = useState<string | null>(null);
  const [category, setCategory] = useState<string | null>(null);
  const [subCategory1, setSubCategory1] = useState<string | null>(null);
  const [subCategory2, setSubCategory2] = useState<string | null>(null);
  const [subCategory3, setSubCategory3] = useState<string | null>(null);
  const [subCategory4, setSubCategory4] = useState<string | null>(null);
  const [subCategory5, setSubCategory5] = useState<string | null>(null);
  const [unitOfMeasure, setUnitOfMeasure] = useState<string | null>(null);
  const [salesPrice, setSalesPrice] = useState<string | null>(null);
  const [barCode, setBarCode] = useState<string | null>(null);
  const [secondaryBarCode, setSecondaryBarCode] = useState<string | null>(null);
  const [tax, setTax] = useState<string | null>(null);
  const [itemType, setItemType] = useState<string | null>("1");
  const [commissionPercent, setCommissionPercent] = useState<string | null>(
    null,
  );
  const [commissionableItem, setCommissionableItem] = useState<string | null>(
    null,
  );
  const [commissionRequired, setCommissionRequired] = useState<string | null>(
    null,
  );
  const [useInventory, setUseInventory] = useState<string | null>(null);
  const [groupingKey, setGroupingKey] = useState<string | null>(null);
  const [openItems, setOpenItems] = useState<string | null>(null);
  const [multipacks, setMultipacks] = useState<string | null>(null);
  const [gratuity, setGratuity] = useState<string | null>(null);
  const [serviceCharge, setServiceCharge] = useState<string | null>(null);
  const [outletCode, setOutletCode] = useState<string | null>(null);
  const [quantity, setQuantity] = useState<string | null>(null);
  const [unitCost, setUnitCost] = useState<string | null>(null);
  const [itemPar, setItemPar] = useState<string | null>(null);
  const [outletSwitch, setOutletSwitch] = useState<string | null>(null);
  const [allowEarn, setAllowEarn] = useState<string | null>(null);
  const [vendorName, setVendorName] = useState<string | null>(null);
  const [vendorItemNo, setVendorItemNo] = useState<string | null>(null);

  const [itemNumberErr, setItemNumberErr] = useState<boolean>(false);
  const [itemDescriptionErr, setItemDescriptionErr] = useState<boolean>(false);
  const [categoryErr, setCategoryErr] = useState<boolean>(false);
  const [barCodeErr, setBarCodeErr] = useState<boolean>(false);
  const [salesPriceErr, setSalesPriceErr] = useState<boolean>(false);
  const [quantityErr, setQuantityErr] = useState<boolean>(false);
  const [unitCostErr, setUnitCostErr] = useState<boolean>(false);

  const [retailRetailItems, setRetailRetailItems] = useState<any[]>([]);
  const [categoryList, setCategoryList] = useState<string[]>([]);
  const [sub1List, setSub1List] = useState<string[]>([]);
  const [sub2List, setSub2List] = useState<string[]>([]);
  const [sub3List, setSub3List] = useState<string[]>([]);
  const [sub4List, setSub4List] = useState<string[]>([]);
  const [sub5List, setSub5List] = useState<string[]>([]);
  const [taxList, setTaxList] = useState<string[]>([]);
  const [outletCodeList, setOutletCodeList] = useState<string[]>([]);
  const [vendorNameList, setVendorNameList] = useState<string[]>([]);

  const [alertMessage, setAlertMessage] = useState<string>("");
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<"success" | "error">("success");
  const [editClicked, setEditClicked] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [lastUpdatedRecord, setLastUpdatedRecord] = useState<any>(null);
  const { topRef, scrollToTop } = useScrollToTop();

  const payload = {
    "Item Number":
      itemNumber != null &&
      String(itemNumber).trim() !== "" &&
      !Number.isNaN(Number(itemNumber))
        ? Number(itemNumber)
        : undefined,
    "Item Description": itemDescription,
    Category: category,
    "Sub Category 1": subCategory1,
    "Sub Category 2": subCategory2,
    "Sub Category 3": subCategory3,
    "Sub Category 4": subCategory4,
    "Sub Category 5": subCategory5,
    "Unit of Measure": unitOfMeasure,
    "Sales Price":
      salesPrice != null &&
      String(salesPrice).trim() !== "" &&
      !Number.isNaN(Number(salesPrice))
        ? Number(salesPrice)
        : undefined,
    "Bar Code":
      barCode != null &&
      String(barCode).trim() !== "" &&
      !Number.isNaN(Number(barCode))
        ? Number(barCode)
        : undefined,
    "Secondary Bar Code": secondaryBarCode,
    Tax: tax,
    "Item Type":
      itemType != null &&
      String(itemType).trim() !== "" &&
      !Number.isNaN(Number(itemType))
        ? Number(itemType)
        : undefined,
    "Commission Percent":
      commissionPercent != null &&
      String(commissionPercent).trim() !== "" &&
      !Number.isNaN(Number(commissionPercent))
        ? Number(commissionPercent)
        : undefined,
    "Commissionable Item":
      commissionableItem != null &&
      String(commissionableItem).trim() !== "" &&
      !Number.isNaN(Number(commissionableItem))
        ? Number(commissionableItem)
        : undefined,
    "Commission Required":
      commissionRequired != null &&
      String(commissionRequired).trim() !== "" &&
      !Number.isNaN(Number(commissionRequired))
        ? Number(commissionRequired)
        : undefined,
    "Use Inventory":
      useInventory != null &&
      String(useInventory).trim() !== "" &&
      !Number.isNaN(Number(useInventory))
        ? Number(useInventory)
        : undefined,
    "Grouping Key":
      groupingKey != null &&
      String(groupingKey).trim() !== "" &&
      !Number.isNaN(Number(groupingKey))
        ? Number(groupingKey)
        : undefined,
    "Open Items":
      openItems != null &&
      String(openItems).trim() !== "" &&
      !Number.isNaN(Number(openItems))
        ? Number(openItems)
        : undefined,
    Multipacks:
      multipacks != null &&
      String(multipacks).trim() !== "" &&
      !Number.isNaN(Number(multipacks))
        ? Number(multipacks)
        : undefined,
    Gratuity:
      gratuity != null &&
      String(gratuity).trim() !== "" &&
      !Number.isNaN(Number(gratuity))
        ? Number(gratuity)
        : undefined,
    "Service Charge":
      serviceCharge != null &&
      String(serviceCharge).trim() !== "" &&
      !Number.isNaN(Number(serviceCharge))
        ? Number(serviceCharge)
        : undefined,
    "Outlet Code": outletCode,
    Quantity:
      quantity != null &&
      String(quantity).trim() !== "" &&
      !Number.isNaN(Number(quantity))
        ? Number(quantity)
        : undefined,
    "Unit Cost":
      unitCost != null &&
      String(unitCost).trim() !== "" &&
      !Number.isNaN(Number(unitCost))
        ? Number(unitCost)
        : undefined,
    "Item Par":
      itemPar != null &&
      String(itemPar).trim() !== "" &&
      !Number.isNaN(Number(itemPar))
        ? Number(itemPar)
        : undefined,
    "Outlet Switch":
      outletSwitch != null &&
      String(outletSwitch).trim() !== "" &&
      !Number.isNaN(Number(outletSwitch))
        ? Number(outletSwitch)
        : undefined,
    "Allow Earn":
      allowEarn != null &&
      String(allowEarn).trim() !== "" &&
      !Number.isNaN(Number(allowEarn))
        ? Number(allowEarn)
        : undefined,
    "Vendor Name": vendorName,
    "Vendor Item #": vendorItemNo,
  };

  const validateInput = () => {
    setItemNumberErr(false);
    setItemDescriptionErr(false);
    setCategoryErr(false);
    setBarCodeErr(false);
    setSalesPriceErr(false);
    setQuantityErr(false);
    setUnitCostErr(false);

    const itemNumTrim = itemNumber?.trim() ?? "";
    if (!itemNumTrim) {
      setItemNumberErr(true);
      return false;
    }
    if (
      !/^\d+$/.test(itemNumTrim) ||
      itemNumTrim.length > validationLength.postTypeNumber
    ) {
      setItemNumberErr(true);
      return false;
    }

    if (!itemDescription || String(itemDescription).trim() === "") {
      setItemDescriptionErr(true);
      return false;
    }
    if (
      !validateString(
        itemDescription,
        validationLength.itemDescription,
        validationType.SPACE,
      )
    ) {
      setItemDescriptionErr(true);
      return false;
    }

    if (!category || String(category).trim() === "") {
      setCategoryErr(true);
      return false;
    }
    if (
      !validateString(
        category,
        validationLength.golfCategoryName,
        validationType.SPACE,
      )
    ) {
      setCategoryErr(true);
      return false;
    }

    const salesTrim = salesPrice?.trim() ?? "";
    if (!salesTrim) {
      setSalesPriceErr(true);
      return false;
    }
    if (!/^(\d+)(\.\d+)?$/.test(salesTrim)) {
      setSalesPriceErr(true);
      return false;
    }

    if (
      barCode != null &&
      String(barCode).trim() !== "" &&
      String(barCode).trim() !== itemNumTrim
    ) {
      setBarCodeErr(true);
      return false;
    }

    if (quantity != null && String(quantity).trim() !== "") {
      if (!/^\d+$/.test(String(quantity).trim())) {
        setQuantityErr(true);
        return false;
      }
    }
    if (unitCost != null && String(unitCost).trim() !== "") {
      if (!/^(\d+)(\.\d+)?$/.test(String(unitCost).trim())) {
        setUnitCostErr(true);
        return false;
      }
    }
    return true;
  };

  const editRetailRetailItems = (list: any) => {
    if (list == null) {
      setSelectedId(null);
      setEditClicked(false);
      setItemNumber(null);
      setItemDescription(null);
      setCategory(null);
      setSubCategory1(null);
      setSubCategory2(null);
      setSubCategory3(null);
      setSubCategory4(null);
      setSubCategory5(null);
      setUnitOfMeasure(null);
      setSalesPrice(null);
      setBarCode(null);
      setSecondaryBarCode(null);
      setTax(null);
      setItemType("1");
      setCommissionPercent(null);
      setCommissionableItem(null);
      setCommissionRequired(null);
      setUseInventory(null);
      setGroupingKey(null);
      setOpenItems(null);
      setMultipacks(null);
      setGratuity(null);
      setServiceCharge(null);
      setOutletCode(null);
      setQuantity(null);
      setUnitCost(null);
      setItemPar(null);
      setOutletSwitch(null);
      setAllowEarn(null);
      setVendorName(null);
      setVendorItemNo(null);
      setItemNumberErr(false);
      setItemDescriptionErr(false);
      setCategoryErr(false);
      setBarCodeErr(false);
      setSalesPriceErr(false);
      setQuantityErr(false);
      setUnitCostErr(false);
      return;
    }
    if (list !== null) {
      setEditClicked(true);
      if (list.id != null) {
        setSelectedId(list.id);
      } else {
        setSelectedId(null);
      }
    }
    setItemNumber(
      list["Item Number"] != null && list["Item Number"] !== ""
        ? String(list["Item Number"])
        : null,
    );
    setItemDescription(list["Item Description"] ?? null);
    setCategory(list?.Category ?? null);
    setSubCategory1(list["Sub Category 1"] ?? null);
    setSubCategory2(list["Sub Category 2"] ?? null);
    setSubCategory3(list["Sub Category 3"] ?? null);
    setSubCategory4(list["Sub Category 4"] ?? null);
    setSubCategory5(list["Sub Category 5"] ?? null);
    setUnitOfMeasure(list["Unit of Measure"] ?? null);
    setSalesPrice(
      list["Sales Price"] != null && list["Sales Price"] !== ""
        ? String(list["Sales Price"])
        : null,
    );
    setBarCode(
      list["Bar Code"] != null && list["Bar Code"] !== ""
        ? String(list["Bar Code"])
        : null,
    );
    setSecondaryBarCode(list["Secondary Bar Code"] ?? null);
    setTax(list?.Tax ?? null);
    setItemType(
      list["Item Type"] != null && list["Item Type"] !== ""
        ? String(list["Item Type"])
        : "1",
    );
    setCommissionPercent(
      list["Commission Percent"] != null && list["Commission Percent"] !== ""
        ? String(list["Commission Percent"])
        : null,
    );
    setCommissionableItem(
      list["Commissionable Item"] != null && list["Commissionable Item"] !== ""
        ? String(list["Commissionable Item"])
        : null,
    );
    setCommissionRequired(
      list["Commission Required"] != null && list["Commission Required"] !== ""
        ? String(list["Commission Required"])
        : null,
    );
    setUseInventory(
      list["Use Inventory"] != null && list["Use Inventory"] !== ""
        ? String(list["Use Inventory"])
        : null,
    );
    setGroupingKey(
      list["Grouping Key"] != null && list["Grouping Key"] !== ""
        ? String(list["Grouping Key"])
        : null,
    );
    setOpenItems(
      list["Open Items"] != null && list["Open Items"] !== ""
        ? String(list["Open Items"])
        : null,
    );
    setMultipacks(
      list?.Multipacks != null && list?.Multipacks !== ""
        ? String(list.Multipacks)
        : null,
    );
    setGratuity(
      list?.Gratuity != null && list?.Gratuity !== ""
        ? String(list.Gratuity)
        : null,
    );
    setServiceCharge(
      list["Service Charge"] != null && list["Service Charge"] !== ""
        ? String(list["Service Charge"])
        : null,
    );
    setOutletCode(list["Outlet Code"] ?? null);
    setQuantity(
      list?.Quantity != null && list?.Quantity !== ""
        ? String(list.Quantity)
        : null,
    );
    setUnitCost(
      list["Unit Cost"] != null && list["Unit Cost"] !== ""
        ? String(list["Unit Cost"])
        : null,
    );
    setItemPar(
      list["Item Par"] != null && list["Item Par"] !== ""
        ? String(list["Item Par"])
        : null,
    );
    setOutletSwitch(
      list["Outlet Switch"] != null && list["Outlet Switch"] !== ""
        ? String(list["Outlet Switch"])
        : null,
    );
    setAllowEarn(
      list["Allow Earn"] != null && list["Allow Earn"] !== ""
        ? String(list["Allow Earn"])
        : null,
    );
    setVendorName(list["Vendor Name"] ?? null);
    setVendorItemNo(list["Vendor Item #"] ?? null);
    setItemNumberErr(false);
    setItemDescriptionErr(false);
    setCategoryErr(false);
    setBarCodeErr(false);
    setSalesPriceErr(false);
    setQuantityErr(false);
    setUnitCostErr(false);
  };

  const updateRetailRetailItems = () => {
    if (!validateInput()) return;
    const itemNumVal =
      itemNumber != null &&
      String(itemNumber).trim() !== "" &&
      !Number.isNaN(Number(itemNumber))
        ? Number(itemNumber)
        : undefined;
    if (
      checkDuplicate(
        retailRetailItems.filter(
          (item: any) => String(item.id) !== String(selectedId),
        ),
        DNDFieldsEnum.ITEMNUMBER,
        itemNumVal,
      )
    ) {
      setAlertMessage("Cannot have duplicate entries");
      setAlertType("error");
      setOpenAlert(true);
      return;
    }
    setItemNumberErr(false);
    setItemDescriptionErr(false);
    setCategoryErr(false);
    setBarCodeErr(false);
    setSalesPriceErr(false);
    setQuantityErr(false);
    setUnitCostErr(false);
    setRetailRetailItems((prev: any[]) =>
      prev.map((item: any) =>
        item.id === selectedId ? { ...item, ...payload } : item,
      ),
    );
    editRetailRetailItems(null);
    setEditClicked(false);
    setSelectedId(null);
    setAlertMessage(`${RetailPropertyEnum.retailItems} updated successfully`);
    setAlertType("success");
    setOpenAlert(true);
  };

  const addRetailRetailItems = () => {
    if (!validateInput()) return;
    const itemNumVal =
      itemNumber != null &&
      String(itemNumber).trim() !== "" &&
      !Number.isNaN(Number(itemNumber))
        ? Number(itemNumber)
        : undefined;
    if (
      checkDuplicate(retailRetailItems, DNDFieldsEnum.ITEMNUMBER, itemNumVal)
    ) {
      setAlertMessage("Cannot have duplicate entries");
      setAlertType("error");
      setOpenAlert(true);
      return;
    }
    setRetailRetailItems((prev: any[]) =>
      updateData(
        prev !== null && prev?.length
          ? [
              ...prev,
              {
                id: retailRetailItems.length + 1,
                ...payload,
              },
            ]
          : [{ id: 1, ...payload }],
      ),
    );
    setLastUpdatedRecord(payload);
    editRetailRetailItems(null);
    setEditClicked(false);
  };

  const deleteRetailRetailItems = (id: number) => {
    setRetailRetailItems(deleteItem(retailRetailItems, id));
  };

  useEffect(() => {
    if (fieldValues) {
      setRetailRetailItems(fieldValues[RetailPropertyEnum.retailItems]);
      setCategoryList(
        fillAutocompleteValues(
          fieldValues[RetailPropertyEnum.retailCategories],
          DNDFieldsEnum.CATEGORYNAME,
          "",
        ),
      );
      setSub1List(
        fillAutocompleteValues(
          fieldValues[RetailPropertyEnum.retailSubCategories],
          DNDFieldsEnum.SUBCATEGORY1,
          "",
        ),
      );
      setSub2List(
        fillAutocompleteValues(
          fieldValues[RetailPropertyEnum.retailSubCategories],
          DNDFieldsEnum.SUBCATEGORY2,
          "",
        ),
      );
      setSub3List(
        fillAutocompleteValues(
          fieldValues[RetailPropertyEnum.retailSubCategories],
          DNDFieldsEnum.SUBCATEGORY3,
          "",
        ),
      );
      setSub4List(
        fillAutocompleteValues(
          fieldValues[RetailPropertyEnum.retailSubCategories],
          DNDFieldsEnum.SUBCATEGORY4,
          "",
        ),
      );
      setSub5List(
        fillAutocompleteValues(
          fieldValues[RetailPropertyEnum.retailSubCategories],
          DNDFieldsEnum.SUBCATEGORY5,
          "",
        ),
      );
      setTaxList(
        fillAutocompleteValues(
          fieldValues[RetailPropertyEnum.taxes],
          DNDFieldsEnum.TAXNAME2,
          "",
        ),
      );
      setOutletCodeList(
        fillAutocompleteValues(
          fieldValues[RetailPropertyEnum.outletSetup],
          DNDFieldsEnum.OUTLETNAME,
          "",
        ),
      );
      setVendorNameList(
        fillAutocompleteValues(
          fieldValues[RetailPropertyEnum.vendorSetup],
          DNDFieldsEnum.VENDORNAME,
          "",
        ),
      );
    }
  }, []);

  useEffect(() => {
    data(retailRetailItems);
    if (editClicked) {
      setSelectedId(
        checkData(retailRetailItems, selectedId) ? selectedId : null,
      );
    }
  }, [retailRetailItems]);

  const itemNumberHelperText = itemNumberErr
    ? !itemNumber || String(itemNumber).trim() === ""
      ? validationMessages.fieldRequired
      : validationMessages.retailRetailItemNumberInvalid
    : fieldValidationHelperText.retailRetailItemNumber;

  const itemDescriptionHelperText = itemDescriptionErr
    ? !itemDescription || String(itemDescription).trim() === ""
      ? validationMessages.fieldRequired
      : validationMessages.retailRetailItemDescriptionInvalid
    : fieldValidationHelperText.retailRetailItemDescription;

  const salesPriceHelperText = salesPriceErr
    ? !salesPrice || String(salesPrice).trim() === ""
      ? validationMessages.fieldRequired
      : validationMessages.retailTaxValueInvalid
    : fieldValidationHelperText.retailRetailItemSalesPrice;

  const barCodeHelperText = barCodeErr
    ? validationMessages.retailRetailItemBarCodeMismatch
    : fieldValidationHelperText.retailRetailItemBarCode;

  const quantityHelperText = quantityErr
    ? validationMessages.retailRetailItemQuantityInvalid
    : fieldValidationHelperText.retailRetailItemOptionalDigits;

  const unitCostHelperText = unitCostErr
    ? validationMessages.retailTaxValueInvalid
    : fieldValidationHelperText.retailRetailItemOptionalNumeric;

  return (
    <Stack direction="column" gap="10px">
      <div ref={topRef} />
      <Stack direction="column" width="100%">
        <Paper
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            padding: "20px",
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            gap="10px"
            mb={4}
          >
            <Typography variant="h6" component="div" sx={textStyle}>
              Retail Items
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.header)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </Typography>
            <Stack direction="row" gap="10px" justifyContent="space-between">
              {editClicked && (
                <ClearButton click={() => editRetailRetailItems(null)} />
              )}
              {lastUpdatedRecord && (
                <CopyButton
                  click={() => {
                    editRetailRetailItems(lastUpdatedRecord);
                  }}
                />
              )}
            </Stack>
          </Stack>

          <Stack>
            <FormLabel component="legend">
              Item Number
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.itemNumber)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <TextField
              id="retailItemNumber"
              variant="outlined"
              placeholder="Item Number"
              value={itemNumber ?? ""}
              helperText={itemNumberHelperText}
              error={itemNumberErr}
              fullWidth
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const v = e.target.value.replace(/\D/g, "");
                setItemNumber(v || null);
                setItemNumberErr(false);
              }}
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Item Description
              <Tooltip
                title={tooltipComponent(
                  retailRetailItemsTooltip.itemDescription,
                )}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <TextField
              id="retailItemDescription"
              variant="outlined"
              placeholder="Item Description"
              value={itemDescription ?? ""}
              helperText={itemDescriptionHelperText}
              error={itemDescriptionErr}
              fullWidth
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setItemDescription(e.target.value || null);
                setItemDescriptionErr(false);
              }}
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Category
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.category)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <Autocomplete
              id="retailItemCategory"
              options={removeSampleTestArray(categoryList ?? [])}
              value={category ?? null}
              onChange={(_e, v) => {
                setCategory(v);
                setCategoryErr(false);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Category"
                  fullWidth
                  error={categoryErr}
                />
              )}
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Sub Category 1
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.subCategory1)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <Autocomplete
              id="retailItemSub1"
              options={removeSampleTestArray(sub1List ?? [])}
              value={subCategory1 ?? null}
              onChange={(_e, v) => setSubCategory1(v)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Sub Category 1"
                  fullWidth
                />
              )}
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Sub Category 2
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.subCategory2)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <Autocomplete
              id="retailItemSub2"
              options={removeSampleTestArray(sub2List ?? [])}
              value={subCategory2 ?? null}
              onChange={(_e, v) => setSubCategory2(v)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Sub Category 2"
                  fullWidth
                />
              )}
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Sub Category 3
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.subCategory3)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <Autocomplete
              id="retailItemSub3"
              options={removeSampleTestArray(sub3List ?? [])}
              value={subCategory3 ?? null}
              onChange={(_e, v) => setSubCategory3(v)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Sub Category 3"
                  fullWidth
                />
              )}
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Sub Category 4
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.subCategory4)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <Autocomplete
              id="retailItemSub4"
              options={removeSampleTestArray(sub4List ?? [])}
              value={subCategory4 ?? null}
              onChange={(_e, v) => setSubCategory4(v)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Sub Category 4"
                  fullWidth
                />
              )}
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Sub Category 5
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.subCategory5)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <Autocomplete
              id="retailItemSub5"
              options={removeSampleTestArray(sub5List ?? [])}
              value={subCategory5 ?? null}
              onChange={(_e, v) => setSubCategory5(v)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Sub Category 5"
                  fullWidth
                />
              )}
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Unit of Measure
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.unitOfMeasure)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <TextField
              id="retailItemUom"
              variant="outlined"
              placeholder="Unit of Measure"
              value={unitOfMeasure ?? ""}
              helperText={
                fieldValidationHelperText.retailRetailItemUnitOfMeasure
              }
              fullWidth
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setUnitOfMeasure(e.target.value || null)
              }
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Sales Price
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.salesPrice)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <TextField
              id="retailItemSalesPrice"
              variant="outlined"
              placeholder="Sales Price"
              value={salesPrice ?? ""}
              helperText={salesPriceHelperText}
              error={salesPriceErr}
              fullWidth
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const raw = e.target.value;
                if (raw === "" || /^\d*\.?\d*$/.test(raw)) {
                  setSalesPrice(raw || null);
                  setSalesPriceErr(false);
                }
              }}
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Bar Code
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.barCode)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <TextField
              id="retailItemBarCode"
              variant="outlined"
              placeholder="Bar Code"
              value={barCode ?? ""}
              helperText={barCodeHelperText}
              error={barCodeErr}
              fullWidth
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const v = e.target.value.replace(/\D/g, "");
                setBarCode(v || null);
                setBarCodeErr(false);
              }}
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Secondary Bar Code
              <Tooltip
                title={tooltipComponent(
                  retailRetailItemsTooltip.secondaryBarCode,
                )}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <TextField
              id="retailItemSecondaryBarCode"
              variant="outlined"
              placeholder="Secondary Bar Code"
              value={secondaryBarCode ?? ""}
              helperText={
                fieldValidationHelperText.retailRetailItemSecondaryBarCode
              }
              fullWidth
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setSecondaryBarCode(e.target.value || null)
              }
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Tax
              <Tooltip title={tooltipComponent(retailRetailItemsTooltip.tax)}>
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <Autocomplete
              id="retailItemTax"
              options={removeSampleTestArray(taxList ?? [])}
              value={tax ?? null}
              onChange={(_e, v) => setTax(v)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Tax"
                  fullWidth
                />
              )}
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Item Type
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.itemType)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <TextField
              id="retailItemItemType"
              variant="outlined"
              placeholder="1"
              value={itemType ?? ""}
              helperText={fieldValidationHelperText.retailRetailItemItemType}
              fullWidth
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setItemType(e.target.value || null)
              }
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Commission Percent
              <Tooltip
                title={tooltipComponent(
                  retailRetailItemsTooltip.commissionPercent,
                )}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <TextField
              id="retailItemCommissionPercent"
              variant="outlined"
              placeholder="Commission Percent"
              value={commissionPercent ?? ""}
              helperText={
                fieldValidationHelperText.retailRetailItemCommissionPercent
              }
              fullWidth
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setCommissionPercent(e.target.value || null)
              }
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Commissionable Item
              <Tooltip
                title={tooltipComponent(
                  retailRetailItemsTooltip.commissionableItem,
                )}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <TextField
              id="retailItemCommissionable"
              variant="outlined"
              placeholder="0 or 1"
              value={commissionableItem ?? ""}
              helperText={
                fieldValidationHelperText.retailRetailItemZeroOneNumeric
              }
              fullWidth
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setCommissionableItem(e.target.value || null)
              }
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Commission Required
              <Tooltip
                title={tooltipComponent(
                  retailRetailItemsTooltip.commissionRequired,
                )}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <TextField
              id="retailItemCommissionReq"
              variant="outlined"
              placeholder="0 or 1"
              value={commissionRequired ?? ""}
              helperText={
                fieldValidationHelperText.retailRetailItemZeroOneNumeric
              }
              fullWidth
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setCommissionRequired(e.target.value || null)
              }
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Use Inventory
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.useInventory)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <TextField
              id="retailItemUseInventory"
              variant="outlined"
              placeholder="0 or 1"
              value={useInventory ?? ""}
              helperText={
                fieldValidationHelperText.retailRetailItemZeroOneNumeric
              }
              fullWidth
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setUseInventory(e.target.value || null)
              }
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Grouping Key
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.groupingKey)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <TextField
              id="retailItemGroupingKey"
              variant="outlined"
              placeholder="Grouping Key"
              value={groupingKey ?? ""}
              helperText={
                fieldValidationHelperText.retailRetailItemOptionalNumeric
              }
              fullWidth
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setGroupingKey(e.target.value || null)
              }
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Open Items
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.openItems)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <TextField
              id="retailItemOpenItems"
              variant="outlined"
              placeholder="Open Items"
              value={openItems ?? ""}
              helperText={
                fieldValidationHelperText.retailRetailItemOptionalNumeric
              }
              fullWidth
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setOpenItems(e.target.value || null)
              }
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Multipacks
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.multipacks)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <TextField
              id="retailItemMultipacks"
              variant="outlined"
              placeholder="Multipacks"
              value={multipacks ?? ""}
              helperText={
                fieldValidationHelperText.retailRetailItemOptionalNumeric
              }
              fullWidth
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setMultipacks(e.target.value || null)
              }
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Gratuity
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.gratuity)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <TextField
              id="retailItemGratuity"
              variant="outlined"
              placeholder="Gratuity"
              value={gratuity ?? ""}
              helperText={
                fieldValidationHelperText.retailRetailItemOptionalNumeric
              }
              fullWidth
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setGratuity(e.target.value || null)
              }
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Service Charge
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.serviceCharge)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <TextField
              id="retailItemServiceCharge"
              variant="outlined"
              placeholder="Service Charge"
              value={serviceCharge ?? ""}
              helperText={
                fieldValidationHelperText.retailRetailItemOptionalNumeric
              }
              fullWidth
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setServiceCharge(e.target.value || null)
              }
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Outlet Code
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.outletCode)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <Autocomplete
              id="retailItemOutletCode"
              options={removeSampleTestArray(outletCodeList ?? [])}
              value={outletCode ?? null}
              disabled={!outletCodeList}
              onChange={(_e, v) => setOutletCode(v)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Outlet Code"
                  fullWidth
                  helperText={
                    fieldValidationHelperText.retailRetailItemOutletCode
                  }
                />
              )}
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Quantity
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.quantity)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <TextField
              id="retailItemQuantity"
              variant="outlined"
              placeholder="Quantity"
              value={quantity ?? ""}
              helperText={quantityHelperText}
              error={quantityErr}
              fullWidth
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const v = e.target.value.replace(/\D/g, "");
                setQuantity(v || null);
                setQuantityErr(false);
              }}
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Unit Cost
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.unitCost)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <TextField
              id="retailItemUnitCost"
              variant="outlined"
              placeholder="Unit Cost"
              value={unitCost ?? ""}
              helperText={unitCostHelperText}
              error={unitCostErr}
              fullWidth
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const raw = e.target.value;
                if (raw === "" || /^\d*\.?\d*$/.test(raw)) {
                  setUnitCost(raw || null);
                  setUnitCostErr(false);
                }
              }}
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Item Par
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.itemPar)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <TextField
              id="retailItemPar"
              variant="outlined"
              placeholder="Item Par"
              value={itemPar ?? ""}
              helperText={fieldValidationHelperText.retailRetailItemItemPar}
              fullWidth
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const v = e.target.value.replace(/\D/g, "");
                setItemPar(v || null);
              }}
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Outlet Switch
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.outletSwitch)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <TextField
              id="retailItemOutletSwitch"
              variant="outlined"
              placeholder="0 or 1"
              value={outletSwitch ?? ""}
              helperText={
                fieldValidationHelperText.retailRetailItemZeroOneNumeric
              }
              fullWidth
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setOutletSwitch(e.target.value || null)
              }
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Allow Earn
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.allowEarn)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <TextField
              id="retailItemAllowEarn"
              variant="outlined"
              placeholder="0 or 1"
              value={allowEarn ?? ""}
              helperText={
                fieldValidationHelperText.retailRetailItemZeroOneNumeric
              }
              fullWidth
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setAllowEarn(e.target.value || null)
              }
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Vendor Name
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.vendorName)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <Autocomplete
              id="retailItemVendorName"
              options={removeSampleTestArray(vendorNameList ?? [])}
              value={vendorName ?? null}
              onChange={(_e, v) => setVendorName(v)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Vendor Name"
                  fullWidth
                />
              )}
            />
          </Stack>
          <Stack>
            <FormLabel component="legend">
              Vendor Item #
              <Tooltip
                title={tooltipComponent(retailRetailItemsTooltip.vendorItemNo)}
              >
                <InfoIcon fontSize="small" />
              </Tooltip>
            </FormLabel>
            <TextField
              id="retailItemVendorItemNo"
              variant="outlined"
              placeholder="Vendor Item #"
              value={vendorItemNo ?? ""}
              helperText={
                fieldValidationHelperText.retailRetailItemVendorItemNo
              }
              fullWidth
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setVendorItemNo(e.target.value || null)
              }
            />
          </Stack>

          <Stack direction="row" width="100%" justifyContent="flex-end">
            <Button
              variant="contained"
              sx={{
                cursor: "pointer",
                border: "1px solid gray",
                borderRadius: "10px",
                background: "darkgreen",
                color: "white",
              }}
              onClick={
                selectedId ? updateRetailRetailItems : addRetailRetailItems
              }
              id="addRetailRetailItem"
            >
              {selectedId ? buttonValues.UPDATE : buttonValues.ADD} Retail Item
            </Button>
          </Stack>

          <Stack direction="column" gap="10px" mt={4}>
            <Typography variant="h6">Retail Items Available</Typography>
            <Typography variant="body2" sx={{ color: "red", fontWeight: 800 }}>
              Do not use sample data. Those are for demo purposes only!
            </Typography>
            <Stack direction="column" gap="10px">
              {retailRetailItems?.length ? (
                <DraggableItemList
                  itemData={retailRetailItems}
                  onOrderUpdate={(order) => setRetailRetailItems(order)}
                  onEdit={(info) => {
                    editRetailRetailItems(info);
                    scrollToTop();
                  }}
                  onDelete={(id) => deleteRetailRetailItems(id)}
                  code={DNDFieldsEnum.ITEMNUMBER}
                  name={"Item Description"}
                />
              ) : (
                <Typography variant="body2">
                  No Retail Items Information Available
                </Typography>
              )}
            </Stack>
          </Stack>
        </Paper>
      </Stack>
      <AlertComponent
        message={alertMessage}
        type={alertType}
        alertOpen={openAlert}
        closeAlert={() => setOpenAlert(false)}
      />
    </Stack>
  );
};

export default RetailRetailItems;
